import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGFormSender} from "vgformsender";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));

		// [vegas]
		VG.log();
		VG.clones();
		VG.fixedHeader($(window));
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.fixedHeader($self);
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	clones: function () {
		if (window.innerWidth <= 1199) {
			let $obj_filters_clone = $('.catalog-categories-clone');
			if ($obj_filters_clone.length) {
				$obj_filters_clone.clone(true).detach();
				$('.catalog-categories-clone-container').append($obj_filters_clone)
			}
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] img').each(function(){
				$(this).closest('a').attr('href', $(this).attr('src'));
			});

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableFormSender();
			VG.plugins.enableFormSendLoadings();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: false
			});
		},

		enableAOS: function ()  {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function ()  {
			//$('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableFormSender: function () {
			const $forms = document.querySelectorAll('[data-vgformsender]');
			if ($forms.length) {
				$forms.forEach(function (form) {
					new VGFormSender(form).submit();
				});
			}
		},

		enableFormSendLoadings: function () {
			$('form').submit(function () {
				let $btn = $(this).find('button[type=submit]');
				let textLoading = $btn.data('loading-text');
				if (textLoading) {
					$btn.text(textLoading).attr('disabled', 'disabled');
				}
			});
		},
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.header-wrapper'),
			scroll = $self.scrollTop();

		if (scroll > 0) {
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
		}
	},
}


export default VGListener;
